import { doccenHTTPRequest } from '../services/axios/httpRequest';

export const getDailyChallengeList = () => {
  return doccenHTTPRequest.get(`/profile/daily-challenge/finished`);
};

export const getDoccoin = () => {
  return doccenHTTPRequest.get(`/profile/doccoin`);
};

export const getRewardMission = () => {
  return doccenHTTPRequest.get(`/mission/bonus-point`);
};
